/* Copyright (c) 2018 Verge Technologies
 * @file nomatch.page.js
 * @author Brenton Watt <brenton@verge.co.za>
 */

import React from 'react';

import Header from '../../components/Header/header';
import Footer from '../../components/Footer/footer';


const ProductGuidePage = (props) => {
  return (
    <div>
      <Header crumbs={props.crumbs} />




	<div className="page-heading heading-about">Product Guide</div>
    <div className="page-content-xxx">
    	<div class="content">
    

                <div id="icontainer" style={{display: "flex",alignItems: "center",justifyContent: "center",width: "100%",height: "120vh"}}>
                    <iframe id="Iframe" src="https://app.powerbi.com/view?r=eyJrIjoiYTMwOGNkOWMtYjQyNi00NWUwLWFjNTktYzg4YjdkOTJmOWIwIiwidCI6IjJiMWQ1ZDllLWEyZTItNDhjNi1hNDdhLTJjNDAwOTkxY2ZlMSJ9" height="100%" style={{width: "100%",height: "100%",border:"none"}}></iframe>
                </div>    
		</div>
	</div>


      
      <Footer />
    </div>
  );
};

export default ProductGuidePage;



// WEBPACK FOOTER //
// ./src/pages/products/product-guide.page.js